module.exports = __webpack_public_path__ + "static/media/stack.4ba59003.png";